<div id="ticketView" *ngIf="ticket" class="container-fluid cw-background manage-view">
  <div class="row">
    <div class="col-12">
      <mat-card class="mat-elevation-z8 my-3 pb-5" id="card">
        <div class="text-left go-back d-block">
          <button (click)="goBack()" disableRipple mat-button class="delete-user p-0">
            <mat-icon matPreffix>arrow_back_ios</mat-icon>
            Go Back
          </button>
          <h6 class="card-title-page mb-4">Ticket:</h6>
        </div>
        <div class="row d-flex">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <app-dynamic-form
              *ngIf="questions"
              [questions]="questions"
              [disabled]="!isEdit"
              (formSubmit)="onUpdateTicket()"
            >
            </app-dynamic-form>
            <button
              class="edit"
              color="primary"
              mat-icon-button
              *ngIf="currentUser.isGlobalAdmin()"
              (click)="onToggleManageTicket()"
            >
              <mat-icon>create</mat-icon><span class="mat-h3"> Edit</span>
            </button>
          </div>
        </div>

        <div class="row d-flex mb-3" #scrollToComments>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <button mat-button (click)="toggleCommentsView()" mat-raised-button color="accent">
              {{ showComments ? "Hide" : "Show" }} Comments
            </button>
          </div>
        </div>
        <mat-divider></mat-divider>

        <div *ngIf="showComments">
          <app-ticket-comments [status]="ticket.status"></app-ticket-comments></div
      ></mat-card>
    </div>
  </div>
</div>
